// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"_25j1I","buttonWrapper":"_25j1I","folder-description":"_2oh6O","folderDescription":"_2oh6O"};